{
  "markread": "marcar sco legì",
  "newest": "pli novas",
  "unread": "nunlegì",
  "starred": "cun staila",
  "tags": "Etichettas",
  "alltags": "tut las etichettas",
  "timestamp": "{0,date} {0,time}",
  "hours": "Avant {0,plural,one {1 ura},other {# uras}}",
  "minutes": "Avant {0,plural,one {1 minuta},other {# minutas}}",
  "seconds": "Avant {0,plural,one {1 secunda},other {# secundas}}",
  "star": "agiuntar staila",
  "unstar": "allontanar staila",
  "mark": "marcar sco legì",
  "unmark": "marcar sco nunlegì",
  "load_img": "chargiar maletgs",
  "open_window": "avrir",
  "searchbutton": "tschertgar",
  "sources": "Funtaunas",
  "source_add": "agiuntar funtauna",
  "source_opml": "u importar ina datoteca opml u da google reader",
  "source_export": "exportar las funtaunas",
  "source_edit": "modifitgar",
  "source_delete": "stizzar",
  "source_warn": "propi stizzar questa funtauna?",
  "source_new": "nova funtauna betg memorisada",
  "source_title": "Titel",
  "source_tags": "Etichettas",
  "source_comma": "seperà entras commas",
  "source_select": "tscherna p.pl. la funtauna",
  "source_type": "Tip",
  "source_save": "memorisar",
  "source_cancel": "interrumper",
  "source_saved": "memorisà",
  "no_entries": "chattà naginas endataziuns",
  "more": "dapli",
  "login": "s'annunziar",
  "login_username": "num d'utilisader",
  "login_password": "pled-clav",
  "no_title": "nagin titel"
}
